const FONT_FAMILY_ATTRIBUTE_REGEX = /font-family="(.*?)"/gi;
const STYLE_ATTRIBUTE_REGEX = /style="(.*?)"/gi;
// the value may hold entity-escaped quotes (`&apos;`), whose own semicolon must not end the declaration
const FONT_FAMILY_DECLARATION_REGEX = /font-family:\s*((?:&[a-z]+;|[^;])*)/gi;
const FONT_FAMILY_QUOTE_OR_QUOTE_ENTITY_REGEX = /['"]|&apos;|&quot;/g;

const unquoteFamilyName = (familyValue: string): string => {
  return familyValue.replace(FONT_FAMILY_QUOTE_OR_QUOTE_ENTITY_REGEX, '').trim();
};

/**
 * Rewrites every SVG `font-family` attribute, and every `font-family:` declaration inside a `style`
 * attribute, to the bare family name.
 *
 * Text items hand fabric a quoted `fontFamily` (`'RasaRegular'`), which fabric copies into the `<text>`
 * attribute and into the per-character `<tspan style="…">` declarations a style run produces; since
 * 7.1.0-pmw-65 it XML-escapes the quotes as `&apos;` / `&quot;` on the way. The PDF generator registers its
 * fonts under the bare name and svg-to-pdfkit passes the value straight to that lookup, so any leftover
 * quote, literal or escaped, makes the lookup miss and the text fall back to Helvetica.
 */
export const unquoteSvgFontFamilyAttributes = (svg: string): string => {
  const withBareAttributes = svg.replace(FONT_FAMILY_ATTRIBUTE_REGEX, (_match: string, familyValue: string): string => {
    return `font-family="${unquoteFamilyName(familyValue)}"`;
  });
  return withBareAttributes.replace(STYLE_ATTRIBUTE_REGEX, (_match: string, declarations: string): string => {
    const bareDeclarations = declarations.replace(FONT_FAMILY_DECLARATION_REGEX, (_declaration: string, familyValue: string): string => {
      return `font-family: ${unquoteFamilyName(familyValue)}`;
    });
    return `style="${bareDeclarations}"`;
  });
};
